interface ConfirmActionModalProps {
    isOpen: boolean
    title: string
    message: string
    confirmLabel?: string
    cancelLabel?: string
    isLoading?: boolean
    variant?: "primary" | "danger"
    onConfirm: () => void
    onCancel: () => void
}

export const ConfirmActionModal = ({
    isOpen,
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    isLoading = false,
    onConfirm,
    onCancel,
}: ConfirmActionModalProps) => {
    if (!isOpen) return null

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
            onClick={onCancel}
        >
            <div
                className="w-full max-w-md rounded-md bg-white p-6 text-center shadow-xl"
                onClick={(event) => event.stopPropagation()}
            >
                <h3 className="text-xl font-bold text-gray-900">{title}</h3>
                <p className="mt-3 text-sm leading-6 text-gray-600">{message}</p>

                <div className="mt-8 flex justify-center gap-3">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={isLoading}
                        className="rounded-md border border-gray-300 px-6 py-2 text-sm font-bold text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="btn-cta rounded-md px-6 py-2 text-sm font-bold disabled:cursor-not-allowed disabled:opacity-60"
                    >
                        {isLoading ? "Processing..." : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}
